import { initTier1NotCheckout } from '@/pages/_shared/not-checkout/tier1'
import { initPageTier } from '@/pages/_shared/tier-utils'
// @ts-expect-error TODO: Convert to TypeScript
import { initializeProduct } from '@/catalog/product'
import { initializeSwiperHeroAndViews } from '@/catalog/product-swiper-hero-and-views'

export const initTier1 = async (): Promise<void> => {
  await initPageTier(1, [
    initTier1NotCheckout,
    // Includes options initialization, which may update the UI selections and hero.
    // Select UI and subtotal calculator will also be initialized.
    initializeProduct,
    // CSS must be loaded eagerly because SSR DOM depends on it
    initializeSwiperHeroAndViews
  ])
  // `webpackPrefetch` prefetches the next tier at `Lowest` network priority when the current tier is loaded,
  // even before the following `import()` is executed.
  import(
    /* webpackChunkName: '@/product/tier2', webpackPrefetch: true */ './tier2'
  ).then(({ initTier2 }) => initTier2())
}

initTier1()
